<template>
  <div style="background-color: #F5F7FA;height: 100%;">
    <div style="padding: 20px;">
      <template>
          <el-col :span="24" style="padding:5px 0">
            <el-col :span="20">
            <Daterange :startTime="startTime"  is-datetime="datetime" :endTime="endTime" @dataChange='dataChange'></Daterange>
            </el-col>
            <el-col :span="4">
              <el-button style="float: right;" size="mini" type="primary" @click="submit">搜索</el-button>
            </el-col>
            </el-col>
          <el-table v-loading="tableLoading"  :data="tableData" :height="300" border style="width: 100%; max-height: 500px ;overflow-y: auto">

            <el-table-column prop="heartBeat" label="心率"></el-table-column>
            <el-table-column prop="respiratoryRate" label="呼吸率" ></el-table-column>
            <el-table-column prop="bodyMove" label="体动" >
              <template slot-scope="scope">
                <span v-if="scope.row.bodyMove==0">否</span>
                <span v-if="scope.row.bodyMove==1">是</span>
              </template>
            </el-table-column>
<!--            <el-table-column prop="temperature" label="温度" ></el-table-column>-->
            <el-table-column prop="onBed" :formatter="isOnBed"  label="是否在床" ></el-table-column>
            <el-table-column prop="sendDateTime" :formatter="getTime" label="发送时间" ></el-table-column>

          </el-table>
          <div style="text-align: left;background-color: #fff;padding: 10px;">
            <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="20"
                  :current-page.sync="currentPage"  @current-change="current_change">
              </el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>


        </template>
    </div>
  </div>
</template>

<script>


import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";
import Daterange from "@/components/Daterange";

export default {
  name: "XinLvPage",
  data() {
    return {
      tableLoading:false,
      userCode: '',
      pageIndex:'',
      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,
      startTime:'',
      endTime:''

    }
  },
  components: {
    Daterange
  },

  methods: {
    init(userCode) {
      this.userCode = userCode;
      this.endTime=timefilters(new Date())
      this.startTime=timefilters(new Date(new Date()-1000 * 60 * 60 * 24 * 7))
      this.getXinLvData();

    },
    dataChange(val){
      this.startTime=val[0]
      this.endTime=val[1]
    },
    closeSelf() {
      this.$emit("closeXinLvPage");
    },
    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getXinLvData();
    },
    submit(){
      this.getXinLvData();
    },
    getTime(row){
      return timefilters(row.sendDateTime)
    },
    isOnBed(row){
      if(row.onBed===2){
        return '离床';
      }
      if(row.onBed===1){
        return '在床';
      }
    },
    getXinLvData(){
      this.tableLoading=true
      this.$axios({
        method: 'post',
        url: this.$deviceUrl + "SBJ/GetHeartRateData",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          userCode: this.userCode,
          startTime:this.startTime,
          endTime:this.endTime,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then(
          (response) => {
            this.tableLoading=false
            if (response.data.error === 0) {
              this.tableData=response.data.data.list;
              this.totalItems=response.data.data.total;
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )

    },




  }


}
</script>

<style lang="scss" scoped>
</style>
